import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import ConfirmationModal from  '@/components/modals/ConfirmationModal';

interface ConfirmationVariables {
    modalTitle: string,
    confirmationQuestion: string,
    leftButton: any,
    rightButton: any,
    modalClassName: string
}


const ConfirmationModalPortal = ()  => {
  
    const [confirmationModalVariables, setConfirmationModalVariables] = useState<ConfirmationVariables>(undefined)
    const [confirmCancelModal, setConfirmCancelModal] = useState<any>(undefined)
    const [onCancel, setOnCancel] = useState<any>(undefined)
    const [onContinue, setOnContinue] = useState<any>(undefined)

    useEffect(() => {
        (window as any).setModal = ({confirmationModalVariables, onCancel, onContinue }) => {
            setModal({confirmationModalVariables, onCancel, onContinue })
        }
    },[])

    function setModal({confirmationModalVariables, onCancel, onContinue }) {
        setConfirmCancelModal(true)
        setConfirmationModalVariables(confirmationModalVariables);
        setOnCancel(() => onCancel);
        setOnContinue(() => onContinue);
    }
    // Container ref
    const targetContainer = document.getElementById('react-modal-portal');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
        <>
        {
            confirmationModalVariables ? 
            <ModalWrapper
                isOpen={confirmCancelModal}
                onRequestClose={() => setConfirmCancelModal(false)}
                className={`${confirmationModalVariables?.modalClassName ? confirmationModalVariables.modalClassName: ''}`}
            >
                <ConfirmationModal
                    confirmationModalVariables={confirmationModalVariables}
                    onLeftButtonClick={() => {
                        onCancel();
                        setConfirmCancelModal(false);
                        setConfirmationModalVariables(undefined);
                    }}
                    onRightButtonClick={() => {
                        onContinue();
                        setConfirmCancelModal(false);
                        setConfirmationModalVariables(undefined);
                    }}
                    modalClassName=''
                />
            </ModalWrapper>
            : <></>
        }</>
        , targetContainer
    );
  
}

export default ConfirmationModalPortal;